// Uses the already filtered/sorted UI rows; never reloads unfiltered report data.
export function creaWorkbookReport(ExcelJS, report) {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "CRM Paghe";
  workbook.created = new Date();
  const money = '#,##0.00 "€"';
  const sheet = (name, columns, rows) => {
    const ws = workbook.addWorksheet(name);
    ws.columns = columns.map(([header, key, width = 24, format]) => ({
      header, key, width, style: format ? { numFmt: format } : {},
    }));
    rows.forEach(row => ws.addRow(row));
    ws.getRow(1).font = { bold: true, color: { argb: "FFFFFFFF" } };
    ws.getRow(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF2563EB" } };
    ws.views = [{ state: "frozen", ySplit: 1 }];
    ws.autoFilter = { from: { row: 1, column: 1 }, to: { row: rows.length + 1, column: columns.length } };
    return ws;
  };
  sheet("Impostazioni", [["Campo", "campo", 35], ["Valore", "valore", 85]], report.impostazioni);
  const columns = [["Periodo", "periodo", 26]];
  if (report.dimensione === "voce") columns.push(["Codice AGO", "codice", 18], ["Voce CRM", "descrizione", 65]);
  else columns.push([report.dimensione === "settore" ? "Settore" : report.dimensione === "cliente" ? "Cliente" : "Referente", "nome", 55]);
  columns.push(["Fatturato", "totale", 22, money]);
  if (report.dimensione === "settore") columns.push(["Quantità adempimenti", "quantita", 24, "#,##0.00"]);
  if (report.confrontoAttivo) columns.push(["Scostamento", "deltaExcel", 20, "0.00%"]);
  if (report.mostraCedolini) {
    columns.push(["Cedolini ordinari", "cedolini", 22, "#,##0"]);
    if (report.mostraMensilitaAggiuntive) columns.push(["Mens. aggiuntive", "mensilitaAggiuntive", 22, "#,##0"]);
    columns.push(["Cedolini totali", "cedoliniTotali", 22, "#,##0"], ["Ricavo/cedolino", "ricavoCedolino", 22, money]);
  }
  const rows = report.dati.map(r => {
    const separator = r.nome.indexOf(" · ");
    return { ...r, codice: separator < 0 ? r.nome : r.nome.slice(0, separator),
      descrizione: separator < 0 ? "" : r.nome.slice(separator + 3),
      deltaExcel: r.delta == null ? null : r.delta / 100 };
  });
  const comparisonSheet = (name, values, label) => sheet(name, [
    [label, "nome", 55],
    [`Fatturato ${report.periodiRiepilogo[0]}`, "prima", 25, money],
    [`Fatturato ${report.periodiRiepilogo[1]}`, "seconda", 25, money],
    ["Scostamento €", "differenza", 24, money], ["Scostamento %", "percentuale", 24, "0.00%"],
  ], values.map(r => {
    const prima = r.prima?.totale || 0, seconda = r.seconda?.totale || 0;
    return { nome: r.descrizione || r.nome, prima, seconda, differenza: seconda - prima, percentuale: prima ? (seconda - prima) / Math.abs(prima) : seconda ? null : 0 };
  }));
  if (report.confrontoAttivo && report.dettaglioConfronto) comparisonSheet("Dettaglio", report.dettaglioConfronto, report.dimensione === "cliente" ? "Cliente" : report.dimensione === "referente" ? "Referente" : report.dimensione === "settore" ? "Settore" : "Voce");
  else sheet("Dettaglio", columns, rows);
  if (report.confrontoAttivo && report.confrontoSezioni) comparisonSheet("Confronto sezioni", report.confrontoSezioni, "Sezione");
  sheet("Totali per sezione", [
    ["Sezione", "numero", 15], ["Descrizione", "descrizione", 40],
    ["Quantità / cedolini", "quantita", 24, "#,##0"], ["Tipo quantità", "tipoQuantita", 28],
    ["Mens. aggiuntive", "mensilitaAggiuntive", 22, "#,##0"], ["Totale", "totale", 22, money],
  ], report.sezioni);
  sheet("Totali per area", [["Area", "nome", 35], ["Totale", "totale", 22, money]], report.aree);
  // Keep the payroll subtotal separate to avoid counting it twice in section totals.
  if (report.payroll) sheet("Payroll complessivo", [
    ["Descrizione", "descrizione", 35], [report.payroll.tipoQuantita || "Cedolini elaborati", "quantita", 24, "#,##0"], ["Totale payroll", "totale", 22, money],
  ], [report.payroll]);
  return workbook;
}
